const screenSizes = {
  xsmall: { min: '0', max: '480px' },
  small: { min: '481px', max: '767px' },
  medium: { min: '768px', max: '969px' },
  large: { min: '970px', max: '1169px' },
  xlarge: { min: '1170px' },
};

export default screenSizes;
